import { initializeConfigs } from './aws-web-worker/config';
import { onMessageHandler } from './aws-web-worker/messages';

self.window = {
  navigator: {
    userAgent: ''
  }
};

initializeConfigs();

self.onmessage = onMessageHandler(self);
